import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'

const TermsofUse = () => {
    const nextTextStyle = {
        fontSize: 'clamp(1rem, 1.3vw, 1.5rem)',
        lineHeight: 1.5,
        color: '#ffffff',
        marginBottom: '15px'
    };
    const mailto = {
        color: '#0fafb7',
    };
    return (
        <div><Header />

            <div className="main-container privacypolicy">
                <h2 style={{ textAlign: "center", marginBottom: "40px" }}>
                    Terms of use

                </h2>

                <p style={{ textAlign: "left" }}>Last Updated: 18th July 2023.</p>
                <p style={{ textAlign: "left" }}>
                    These Terms of Use govern your use of Code Buddy’s services and website. By accessing or using our services, you agree to comply with these Terms. If you do not agree with any part of these Terms, please refrain from using our services.</p>

                {/* 1. Use of Services */}
                <p className="label-text" style={{ color: "#0fafb7" }}>
                    1. Use of Services:
                </p>
                <p style={nextTextStyle}>
                    You must be at least 18 years old or the legal age of majority in your
                    jurisdiction to use our services. By using our services, you represent
                    and warrant that you meet these eligibility requirements. To access
                    certain features of our services, you may need to create a user account.
                    You are responsible for maintaining the confidentiality of your account
                    credentials and for all activities that occur under your account. You
                    must notify us immediately of any unauthorized access to or use of your
                    account. When using our services, you agree not to engage in any
                    activities that violate any applicable laws, regulations, or
                    third-party rights. You also agree not to interfere with or disrupt the
                    functionality of our services, attempt to gain unauthorized access to
                    our systems or other users’ accounts, or engage in any fraudulent or
                    deceptive practices.
                </p>

                {/* 2. Service Limitations and Modifications */}
                <p className="label-text" style={{ color: "#0fafb7" }}>
                    2. Service Limitations and Modifications:
                </p>
                <p style={nextTextStyle}>
                    We reserve the right to modify, suspend, or discontinue any part of our
                    services at any time without prior notice. We shall not be liable to
                    you or any third party for any modifications, suspensions, or
                    discontinuations of our services.
                </p>

                {/* 3. Intellectual Property */}
                <p className="label-text" style={{ color: "#0fafb7" }}>
                    3. Intellectual Property:
                </p>
                <p style={nextTextStyle}>
                    All intellectual property rights related to our services and website,
                    including but not limited to copyrights, trademarks, trade secrets, and
                    patents, are owned by Code Buddy’s or our licensors. You may not use,
                    reproduce, distribute, or modify any copyrighted materials without our
                    prior written consent. By submitting any content to our services, you
                    grant us a non-exclusive, worldwide, royalty-free, sublicensable license
                    to use, reproduce, modify, adapt, publish, display, and distribute your
                    content for the purpose of providing and promoting our services. You
                    retain ownership of your content.
                </p>

                {/* 4. Third-Party Links and Content */}
                <p className="label-text" style={{ color: "#0fafb7" }}>
                    4. Third-Party Links and Content:
                </p>
                <p style={nextTextStyle}>
                    Our services may contain links to third-party websites or content that
                    are not owned or controlled by Code Buddy’s. We do not endorse or assume
                    any responsibility for the content or privacy practices of third-party
                    websites. Your interactions with such websites are solely at your own
                    risk.
                </p>

                {/* 5. Limitation of Liability */}
                <p className="label-text" style={{ color: "#0fafb7" }}>
                    5. Limitation of Liability:
                </p>
                <p style={nextTextStyle}>
                    To the fullest extent permitted by applicable law, Code Buddy’s and its
                    affiliates, officers, directors, employees, and agents shall not be
                    liable for any direct, indirect, incidental, consequential, or special
                    damages arising out of or in connection with your use of our services,
                    even if advised of the possibility of such damages.
                </p>

                {/* 6. Indemnification */}
                <p className="label-text" style={{ color: "#0fafb7" }}>
                    6. Indemnification:
                </p>
                <p style={nextTextStyle}>
                    You agree to indemnify and hold Code Buddy’s and its affiliates,
                    officers, directors, employees, and agents harmless from any claims,
                    demands, damages, liabilities, and expenses (including reasonable
                    attorneys’ fees) arising out of or in connection with your use of our
                    services, your violation of these Terms, or your violation of any
                    applicable laws or regulations.
                </p>

                {/* 7. Termination */}
                <p className="label-text" style={{ color: "#0fafb7" }}>
                    7. Termination:
                </p>
                <p style={nextTextStyle}>
                    We may, at our sole discretion, terminate or suspend your access to our
                    services without prior notice for any reason, including, but not
                    limited to, a violation of these Terms.
                </p>

                {/* 8. Governing Law and Dispute Resolution */}
                <p className="label-text" style={{ color: "#0fafb7" }}>
                    8. Governing Law and Dispute Resolution:
                </p>
                <p style={nextTextStyle}>
                    These Terms shall be governed by and construed in accordance with the
                    laws of [insert jurisdiction]. Any disputes arising out of or in
                    connection with these Terms shall be subject to the exclusive
                    jurisdiction of the courts of [insert jurisdiction].
                </p>

                {/* 9. Changes to the Terms */}
                <p className="label-text" style={{ color: "#0fafb7" }}>
                    9. Changes to the Terms:
                </p>
                <p style={nextTextStyle}>
                    We reserve the right to update or modify these Terms at any time without
                    prior notice. By continuing to use our services after any modifications,
                    you agree to be bound by the revised Terms.
                </p>

                <p style={nextTextStyle}>
                    If you have any questions, concerns, or feedback regarding these Terms,
                    please contact us at{" "}
                    <a href="mailto:info@codebuddys.in" style={mailto}>
                        info@codebuddys.in
                    </a>
                    .
                </p>

                
            </div>
            <Footer /></div>
    )
}

export default TermsofUse